import { render, staticRenderFns } from "./VgtFilterRow.vue?vue&type=template&id=1013e8ac&scoped=true"
import script from "./VgtFilterRow.vue?vue&type=script&lang=js"
export * from "./VgtFilterRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013e8ac",
  null
  
)

export default component.exports